export function galleryFader() {
  let current = 0;
  const items = document.getElementsByClassName('hero__galery');

  //console.log(items.length);

  if( items.length >= 2 ) {
    setInterval( function() {
      for( let i = 0; i < items.length; i++ ) {
        items[i].style.opacity = 0;
      }

      current = ( current != items.length - 1 ) ? current + 1 : 0;

      items[current].style.opacity = 0.8;
    }, 4000);
  }
}
